import React, { Fragment, useState } from "react";
import {
  Button,
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  DialogTitle,
  Checkbox,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { ToggleOffOutlined, ToggleOnOutlined } from "@mui/icons-material";

import { useAxios } from "../../../../hooks";
import {
  ActiveTextEighteen,
  TextFourteenBlack,
} from "../../../css components/Style";
import { alert } from "../../../../redux/slices/alertSlice";
import languageTranslator from "../../../../utils/languageTranslator";
import { titleCase } from "change-case-all";

export default function LockCampaignDialog({
  formikProps,
  dialogState,
  setDialogState,
  setAudienceData,
  setEditState,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const [language, setLanguage] = useState("en");

  const handleClose = () => {
    setDialogState({ ...dialogState, state: false });
  };

  return (
    <React.Fragment>
      <MUIDialog open={dialogState.state} onClose={handleClose}>
        <DialogTitle style={{ paddingBottom: "0px" }}>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <Typography style={{ fontWeight: 500 }}>
              {dialogState.component === "lockCampaign"
                ? "Lock My Campaign"
                : languageTranslator("Request Status", language)}
            </Typography>

            <div style={{ display: "flex" }}>
              <Typography>EN</Typography>
              <Checkbox
                style={{
                  padding: "3px 9px",
                  position: "relative",
                  top: "-9px",
                }}
                onChange={(e) => {
                  if (e.target.checked) {
                    setLanguage("id");
                  } else {
                    setLanguage("en");
                  }
                }}
                icon={<ToggleOffOutlined fontSize="large" />}
                checkedIcon={
                  <ToggleOnOutlined fontSize="large" style={{ color: "red" }} />
                }
              />
              <Typography>ID</Typography>
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            {dialogState.component === "lockCampaign" && (
              <TextFourteenBlack>
                {languageTranslator(
                  "By proceeding with this action, you acknowledge the following:",
                  language
                )}
                <br />◉{" "}
                {languageTranslator(
                  "You are affirming your commitment to the selected audience.",
                  language
                )}
                <br />◉{" "}
                {languageTranslator(
                  "Once locked, changes to the audience cannot be made within this campaign.",
                  language
                )}
                <br />◉{" "}
                {languageTranslator(
                  "The attached audience will be locked and cannot be edited.",
                  language
                )}
              </TextFourteenBlack>
            )}

            {dialogState.component === "params" && (
              <TextFourteenBlack variant="">
                {languageTranslator(
                  "Below is the current status of the requested attributes. The mandatory attributes have to be accepted before you can proceed.",
                  language
                )}
              </TextFourteenBlack>
            )}

            {dialogState.component === "params" && (
              <ActiveTextEighteen>
                {formikProps.values.missedParameter.map((val, index) =>
                  Object.keys(val).map((key) => (
                    <Fragment>
                      <Typography key={index} style={{ margin: "10px 0" }}>
                        {key && titleCase(key?.replace(/_/g, " "))}
                      </Typography>
                      <div style={{ marginLeft: "25px" }}>
                        {val?.[key]?.map((v) => (
                          <Typography>- {v}</Typography>
                        ))}
                      </div>
                    </Fragment>
                  ))
                )}
              </ActiveTextEighteen>
            )}
          </DialogContentText>
        </DialogContent>

        {dialogState.component === "lockCampaign" && (
          <DialogActions style={{ padding: "0px 24px 16px" }}>
            <Button onClick={handleLocking} variant="contained" autoFocus>
              Confirm
            </Button>

            <Button onClick={handleClose} variant="outlined" autoFocus>
              Cancel
            </Button>
          </DialogActions>
        )}

        {dialogState.component === "launchCampaign" && (
          <DialogActions style={{ padding: "0px 24px 16px" }}>
            <Button onClick={handleClose} variant="outlined" autoFocus>
              Cancel
            </Button>
          </DialogActions>
        )}
      </MUIDialog>
    </React.Fragment>
  );

  function handleLocking() {
    axios({
      url: "/user/lockCampaign",
      disableRedirect: true,
      method: "POST",
      data: {
        campaign_id: dialogState.data.campaignID,
        sender_brandId: dialogState.data.brandID,
      },
    }).then((response) => {
      if (response.status) {
        axios({
          url:
            "/user/brand/getCampaign?brandId=" +
            parseInt(dialogState.data.brandID) +
            "&campaignId=" +
            parseInt(dialogState.data.campaignID),
        }).then((res) => {
          if (res.status) {
            setAudienceData((prev) => ({
              ...prev,
              isEditable: res.data?.audience?.is_editable,
            }));
            setEditState(false);
            formikProps.setValues((prev) => ({
              ...prev,
              campaign_status: res.data.campaign_status,
              campaignStatus: res.data.campaignStatus,
              isReadyMycampaign: res.data.isReadyMycampaign,
              displayMessage: res.data.displayMessage,
              campaignIsEditable: response?.is_editable,
            }));
          }
        });

        dispatch(
          alert({
            type: "success",
            message: response.message?.displayMessage,
          })
        );
      } else {
        dispatch(
          alert({
            type: "error",
            message: response.message,
          })
        );
      }

      handleClose();
    });
  }
}
